import { useContext } from 'react';

import { RegistrationContext, type RegistrationContextValue } from './registration-context';

/** Access the registration context. Throws if used outside a RegistrationProvider. */
export function useRegistration(): RegistrationContextValue {
  const context = useContext(RegistrationContext);
  if (context === null) {
    throw new Error('useRegistration must be used within a <RegistrationProvider>.');
  }
  return context;
}
